export default "__VITE_ASSET__D6$A$l1P__"